import { useIsAuthenticated } from '@azure/msal-react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { principalServiceRequest } from '../../utils/principal-service/base-request';
import { Principal } from '../../utils/types';

export const usePrincipals = (): UseQueryResult<Principal[]> => {
  const isAuthenticated = useIsAuthenticated();
  return useQuery({
    queryFn: async () => {
      return await principalServiceRequest<Principal[]>('get', 'principals');
    },
    enabled: isAuthenticated,
    queryKey: ['principals'],
    select: ({ data }) => data,
  });
};
